require("./aresLoansMortgagesContractView.scss");

const PropTypes = require("prop-types");

// @vendor
const React = require("react");
const { connect } = require("react-redux");
const { withRouter } = require("react-router-dom");
// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKCover } = require("commonsComponents/OKCover");
const { OKHeaderSubPage } = require("commonsComponents/OKHeaderSubPage");
const { OKSectionBox } = require("commonsComponents/OKSectionBox");
const { OKCheckbox } = require("commonsComponents/OKCheckbox");
const { OKButton } = require("commonsComponents/OKButton");
const { LoadingSection } = require("commonsComponents/loadingSection");
const { OKMessage } = require('commonsComponents/OKMessage');
// @components
const ContractAresLoanSidebar = require("../../components/contracts/contractAresLoan/contractAresLoanSidebar/contractAresLoanSidebar");
const ContractAresLoanRequestError = require("../../components/contracts/contractAresLoan/contractAresLoanRequestError/contractAresLoanRequestError");
const AresLoansMortgagesModal = require("./aresLoansMortgagesModal/aresLoansMortgagesModal");
//@core
const { formatText, FormattedText } = require("core/i18n").i18n;
// @actions
const {
    retrieveAresDossier,
    setAresConsentsDossier,
} = require("../../actions/aresDossier");
// @constants
const {
    NOT_ALLOWED_LOANS_CONTRACTING_ARES_COUNTRIES,
} = require("constants/flagBasedFeatures");
const dossierStatus = require("../../loansConstants/dossierStatus");
const {
    PAGE_ARES_LOANS_MORTGAGES_CONTRACT,
    recordLink,
    recordLinkV2,
    recordPathV2,
} = require("utilities/tagging");

const ARES_CONTEXT = "aresLoan-";
const BASE_CONTEXT = `${ARES_CONTEXT}mbBanking.products.loansAndMortgages.productContracting.aresLoanContracting.mbAresLoanContracting.`;
//@analytics
const { analyticsId, catalogue } = require('../../components/contracts/contractAresLoan/analytics/contractAresLoanAnalytics');

class AresLoansMortgagesContractView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            confirmCheckbox: false,
            confirmVedaconConsent: false,
            openVedaconConsentModal: true,
            isOpenVedaconConsentModal: false,
            readVedaconConsent: false,
            isOpenVedaconDocumentModal: false,
        };

        this.handleConfirmCheckbox = this.handleConfirmCheckbox.bind(this);
        this.handleSetConsentsDossier = this.handleSetConsentsDossier.bind(this);
        this.handleVedaconConsent = this.handleVedaconConsent.bind(this);
        this.handleOpenVedaconDocumentModal = this.handleOpenVedaconDocumentModal.bind(this);
    }

    componentDidMount() {
        const { immFlagBasedFeatures, immAresDossier, retrieveAresDossier } =
            this.props;
        if (
            !immFlagBasedFeatures.get(
                NOT_ALLOWED_LOANS_CONTRACTING_ARES_COUNTRIES
            )
        ) {
            this.props.history.push('/myprofile/loans-mortgages');
        } else if (!immAresDossier.get("dossier")) {
            retrieveAresDossier();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immAresDossier } = nextProps;
        const dossier = immAresDossier.get("dossier");
        if (
            dossier !== null &&
            (dossier.get("status") === dossierStatus.WAIT_DOCUMENTS || dossier.get("status") === dossierStatus.STANDBY)
            ) {
            this.props.history.push('/myprofile/loans-mortgages/ares-confirmation');
            } else if (
                !dossier ||
            dossier.get("status") !== dossierStatus.WAIT_RNC_DATA
            ) {
            this.props.history.push('/myprofile/loans-mortgages');
        }
    }

    handleConfirmCheckbox() {
        this.setState({ confirmCheckbox: !this.state.confirmCheckbox }, () => {
            recordLink(
                PAGE_ARES_LOANS_MORTGAGES_CONTRACT,
                "autorizacion datos correctos checkbox",
                this.state.confirmCheckbox ? "checked" : "unchecked"
            );
        });
    }

    handleVedaconConsent() {
        const { confirmVedaconConsent } = this.state;

        this.setState({ confirmVedaconConsent: !confirmVedaconConsent, readVedaconConsent: false }, () => {
            recordLinkV2({ categoriaEvento: PAGE_ARES_LOANS_MORTGAGES_CONTRACT, accionEvento: "autorizacion consulta de datos TGSS checkbox", etiquetaEvento: this.state.confirmVedaconConsent ? "checked" : "unchecked" });
        });
    }

    handleCloseVedaconConsentsModal(event) {
        recordLinkV2({ categoriaEvento: PAGE_ARES_LOANS_MORTGAGES_CONTRACT, accionEvento: "autorizacion consulta de datos TGSS", etiquetaEvento: event });
        this.setState({
            isOpenVedaconConsentModal: false,
            openVedaconConsentModal: event === 'salir',
            confirmVedaconConsent: event === 'Dar consentimiento',
        });
    }

    handleOpenVedaconDocumentModal() {
        const { confirmVedaconConsent, readVedaconConsent } = this.state;
        this.setState({ isOpenVedaconDocumentModal: true });
        if(confirmVedaconConsent && readVedaconConsent) {
            recordLinkV2({ categoriaEvento: PAGE_ARES_LOANS_MORTGAGES_CONTRACT, accionEvento: "autorizacion consulta de datos TGSS", etiquetaEvento: "volver a leer" });
        } else {
            recordLinkV2({ categoriaEvento: PAGE_ARES_LOANS_MORTGAGES_CONTRACT, accionEvento: "autorizacion consulta de datos TGSS", etiquetaEvento: "leer" });
        }
        recordLinkV2({ categoriaEvento: PAGE_ARES_LOANS_MORTGAGES_CONTRACT, accionEvento: "abrir" });
        recordPathV2(catalogue[analyticsId.VEDACON_DOCUMENT_MODAL_VIEW]());
    }

    handleCloseVedaconDocumentModal(accepted) {
        const { readVedaconConsent } = this.state;
        let value = readVedaconConsent;
        if (accepted === 'continuar') value = true;
        if (accepted === 'cancelar') value = false;

        this.setState({ isOpenVedaconDocumentModal: false, readVedaconConsent: value });
        recordLinkV2({ categoriaEvento: PAGE_ARES_LOANS_MORTGAGES_CONTRACT, accionEvento: accepted });
    }

    handleSetConsentsDossier() {
        const { immAresDossier, setAresConsentsDossier } = this.props;
        const { openVedaconConsentModal, confirmCheckbox, confirmVedaconConsent, readVedaconConsent } = this.state;

        if (openVedaconConsentModal && !confirmVedaconConsent) {
            this.setState({ openVedaconConsentModal: false, isOpenVedaconConsentModal: true });
            recordLinkV2({ eventCategory: PAGE_ARES_LOANS_MORTGAGES_CONTRACT, eventAction: "autorizacion consulta datos TGSS", eventLabel: "abrir"});
        }
        else {
            if (immAresDossier.get("dossier") && immAresDossier.get("dossier").get("status") === dossierStatus.WAIT_RNC_DATA) {
                recordLink(
                    PAGE_ARES_LOANS_MORTGAGES_CONTRACT,
                    "autorizacion consulta datos TGSS",
                    "entendido"
                );

                let consents = [];
                let cirbeAcceptedText = undefined;
                let vedaconAcceptedText = undefined;
                if (confirmCheckbox) {
                    consents.push("CIRBE");
                    cirbeAcceptedText = formatText(`${BASE_CONTEXT}confirmDataCheckBoxDescription`);
                }
                if (confirmVedaconConsent && readVedaconConsent) {
                    consents.push("VEDACON");
                    vedaconAcceptedText = formatText(`${BASE_CONTEXT}mbAresLoanContracting.weWantYouEnjoyCheckBoxDescription`);
                }

                setAresConsentsDossier(consents, cirbeAcceptedText, vedaconAcceptedText);
            }
        }
    }

    buildBreadcrumbConfig() {
        return [
            {
                text: formatText("breadcrumb-loansAndMortgages"),
                url: "/myprofile/loans-mortgages",
                onLinkClick: () => recordLinkV2(catalogue[analyticsId.CLICK_BREADCRUMB_01]()),
            },
            {
                text: formatText("breadcrumb-payrollLoanContract"),
            },
        ];
    }

    buildSidebar() {
        const { immAresDossier } = this.props;
        const contractingData = immAresDossier
            .get("dossier")
            .get("contractingData");
        const paymentDayType = contractingData.get("paymentDayType");

        return (
            <ContractAresLoanSidebar
                contractingData={contractingData}
                paymentDayType={paymentDayType}
            />
        );
    }

    builDisclaimerText() {
        return (
            <div className="ares-loans-mortgages-contract-view__superscript-info">
                <FormattedText value={`${BASE_CONTEXT}openingFeeLabelText`} />
            </div>
        )
    }

    buildVedaconConsentModal() {
        const { isOpenVedaconConsentModal } = this.state;

        return (
            <OKModal
                isOpen={isOpenVedaconConsentModal}
                title={formatText(`${BASE_CONTEXT}mbSocialSecurityConsent.modalTitle`)}
                footerType={'navigation'}
                content={formatText(`${BASE_CONTEXT}mbSocialSecurityConsent.modalDescription`)}
                onCloseCallback={() => this.handleCloseVedaconConsentsModal('salir')}
                primaryButtonText={formatText(`${BASE_CONTEXT}mbSocialSecurityConsent.modalNavigationSeeConsentButton`)}
                onPrimaryButtonClick={() => this.handleCloseVedaconConsentsModal('Dar consentimiento')}
                secondaryButtonText={formatText(`${BASE_CONTEXT}mbSocialSecurityConsent.modalNavigationProvideDocumentLink`)}
                onSecondaryButtonClick={() => this.handleCloseVedaconConsentsModal('Prefiero aportar el documento')}
            />
        )
    }

    buildVedaconDocumentModal() {
        const { isOpenVedaconDocumentModal } = this.state;
        return (
            <AresLoansMortgagesModal
                isOpenModal={isOpenVedaconDocumentModal}
                onCloseModal={event => this.handleCloseVedaconDocumentModal(event)}
                documents={"https://www.openbank.es/assets/static/pdf/Productos/Otros/Consulta_Tesoreria.pdf"}

            />
        );
    }

    buildVedaconConsents() {
        const customIcon = <i className="ares-loans-mortgages-contract-view__icon-lightning" />;
        const { confirmVedaconConsent, readVedaconConsent, openVedaconConsentModal } = this.state;
        const handleTooltipClik = () => {
            recordLinkV2(catalogue[analyticsId.CLICK_TOOLTIP_VEDACON_CONSENTS]());
        }

        return (
            <div  className="ares-loans-mortgages-contract-view__acept-consents">
                <OKMessage customIcon={customIcon} title={formatText(`${BASE_CONTEXT}mbAresLoanContracting.weWantYouEnjoySubtitle`)}>
                    <div className="ares-loans-mortgages-contract-view__acept-consents-content">
                        <div className="text-with-tooltip">
                            <FormattedText value={`${BASE_CONTEXT}mbAresLoanContracting.weWantYouEnjoyDescription`} />
                            <OKTooltip
                                alternativeIcon={true}
                                content={formatText(`${BASE_CONTEXT}mbAresLoanContracting.weWantYouEnjoyTooltipDescription`)}
                                modifier="dark-bg"
                                offset={[10, 0]}
                                placement="top"
                                type="custom"
                                onTooltipClick={handleTooltipClik}
                            />
                        </div>
                        <OKCheckbox
                            idName="ares-loans-mortgages-contract-consents-checkbox"
                            label={formatText(`${BASE_CONTEXT}mbAresLoanContracting.weWantYouEnjoyCheckBoxDescription`)}
                            onChange={this.handleVedaconConsent}
                            value={confirmVedaconConsent}
                            extraClass={!confirmVedaconConsent && !openVedaconConsentModal ? 'highlight-checkbox' : ''}
                        />
                        {confirmVedaconConsent && readVedaconConsent && (
                            <div className="ares-loans-mortgages-contract-view__read-consents-content">
                                <OKButton
                                    onClick={this.handleOpenVedaconDocumentModal}
                                    modifier={'link-emphasize'}
                                >
                                    <FormattedText value={`${BASE_CONTEXT}mbAresLoanContracting.officialDocumentLink`} />
                                </OKButton>
                                <div className={`contract-ares-loan-step-two__read-legal-info__read-button`}>
                                    <i className="signature-pattern-code-input__icon icon icon-check"/>
                                    <FormattedText value={`${BASE_CONTEXT}mbAresLoanContracting.readHelpDescription`} />
                                </div>
                            </div>
                        )}
                    </div>
                </OKMessage>
                {confirmVedaconConsent && !readVedaconConsent && (
                    <div className="ares-loans-mortgages-contract-view__read-consents">
                        <OKMessage title={formatText(`${BASE_CONTEXT}mbAresLoanContracting.readAndAcceptLegaInfoLabel`)}>
                            <div className="ares-loans-mortgages-contract-view__no-read-consents-content">
                                <FormattedText value={`${BASE_CONTEXT}mbAresLoanContracting.readyAndAcceptLegaInfoLabelDescription`} />
                                <OKButton
                                    onClick={this.handleOpenVedaconDocumentModal}
                                    modifier={'secondary'}
                                >
                                    <FormattedText value={`${BASE_CONTEXT}mbAresLoanContracting.readButton`} />
                                </OKButton>
                            </div>
                        </OKMessage>
                    </div>
                )}
            </div>
        );
    }

    buildContent() {
        const { confirmCheckbox, confirmVedaconConsent, readVedaconConsent } = this.state;
        const sidebar = this.buildSidebar();
        const disclaimerText = this.builDisclaimerText();
        const consents = this.buildVedaconConsents();
        const consentsModal = this.buildVedaconConsentModal();
        const documentModal = this.buildVedaconDocumentModal();

        const content = (
            <React.Fragment>
                <div className="ok-section-box__sub-title">
                    {formatText(`${BASE_CONTEXT}loanSummaryDescription`)}
                </div>
                {consents}
                <OKCheckbox
                    idName="ares-loans-mortgages-contract-confirm-checkbox"
                    label={formatText(
                        `${BASE_CONTEXT}confirmDataCheckBoxDescription`
                    )}
                    onChange={this.handleConfirmCheckbox}
                    value={confirmCheckbox}
                />
                {consentsModal}
                {documentModal}
            </React.Fragment>
        );

        const footer = (
            <React.Fragment>
                <OKButton
                    disabled={!confirmCheckbox || (confirmVedaconConsent && !readVedaconConsent)}
                    onClick={this.handleSetConsentsDossier}
                >
                    {formatText(`${BASE_CONTEXT}navigationUnderstoodButton`)}
                </OKButton>
            </React.Fragment>
        );

        return (
            <React.Fragment>
                <div className="col-xs-8">
                    <OKSectionBox
                        title={formatText(`${BASE_CONTEXT}loanSummaryTitle`)}
                        className="ok-section-box"
                    >
                        {content}
                    </OKSectionBox>
                    <OKSectionBox className="ok-section-box-footer">
                        {footer}
                    </OKSectionBox>
                    {disclaimerText}
                </div>
                <div className="col-xs-4">{sidebar}</div>
            </React.Fragment>
        );
    }

    buildHeader() {
        const breadcrumb = this.buildBreadcrumbConfig();

        return (
            <OKCover
                size="medium"
                section="generic"
                customClass="ares-loans-mortgages-contract-view__header"
            >
                <OKHeaderSubPage
                    breadcrumbConfig={breadcrumb}
                    finalTitle={formatText(`${BASE_CONTEXT}header`)}
                    />
            </OKCover>
        );
    }

    render() {
        let content;
        const { immAresDossier } = this.props;
        const error = immAresDossier.get("error");
        const showLoading = immAresDossier.get("isFetching");

        if (showLoading) {
            content = <LoadingSection />;
        } else if (error) {
            content = <ContractAresLoanRequestError error={error} />;
        } else {
            content = this.buildContent();
        }

        const header = this.buildHeader();

        return (
            <article className="ares-loans-mortgages-contract-view">
                {header}
                <section className="ares-loans-mortgages-contract-view__body">
                    {content}
                </section>
            </article>
        );
    }
}

AresLoansMortgagesContractView.propTypes = {
    immFlagBasedFeatures: PropTypes.object.isRequired,
    retrieveAresDossier: PropTypes.func.isRequired,
    setAresConsentsDossier: PropTypes.func.isRequired,
    immAresDossier: PropTypes.object,
    history: PropTypes.object.isRequired,
};

module.exports = withRouter(connect(
    (state) => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immAresDossier: state.aresDossier,
    }),
    {
        retrieveAresDossier: retrieveAresDossier,
        setAresConsentsDossier: setAresConsentsDossier,
    }
)(AresLoansMortgagesContractView));
